import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { cn } from '@/shared/lib/utils'
import type { LlmChatSessionScopeDisplay } from '../llmChatSessionScopeLabel'

type LlmChatSessionScopeHeaderProps = {
  title: string
  scope: LlmChatSessionScopeDisplay | null
  productId?: string | null
  isScopeLoading: boolean
  className?: string
}

export function LlmChatSessionScopeHeader({
  title,
  scope,
  productId,
  isScopeLoading,
  className,
}: LlmChatSessionScopeHeaderProps) {
  const { t } = useTranslation('llmChat')

  let scopeSubtitle: string | null = null
  if (isScopeLoading) {
    scopeSubtitle = t('sessionScope.loading')
  } else if (scope !== null) {
    scopeSubtitle = scope.label
  }
  const trimmedProductId = productId?.trim()
  const showViewProductButton =
    scope?.scopeKind === 'product' &&
    trimmedProductId !== undefined &&
    trimmedProductId !== null &&
    trimmedProductId.length > 0

  return (
    <div
      className={cn(
        'shrink-0 border-b border-border/60 bg-muted/30 px-4 py-3',
        className
      )}
    >
      <div className='flex items-start justify-between gap-3'>
        <p className='truncate text-sm font-semibold text-foreground'>{title}</p>
        {showViewProductButton ? (
          <Button asChild variant='outline' size='sm' className='h-7 px-2'>
            <Link to={`/product-catalog/${trimmedProductId}`}>
              {t('viewProduct')}
            </Link>
          </Button>
        ) : null}
      </div>
      {scopeSubtitle !== null ? (
        <div className='mt-0.5 flex min-w-0 items-center gap-1.5'>
          {isScopeLoading ? (
            <Loader2
              className='size-3 shrink-0 animate-spin text-muted-foreground'
              aria-hidden
            />
          ) : null}
          <p className='truncate text-xs text-muted-foreground'>
            {scopeSubtitle}
          </p>
        </div>
      ) : null}
    </div>
  )
}
